import clsx from 'clsx';
import { Platforms } from '@/common/constants';
import { usePlatform } from '@/common/hooks';
import { StatisticsSkeleton } from '@/ui/components';
import { TrackingElements, TrackingEvents, TrackingTabs, useTrack } from '../../tracking';
import { NoDataError, UnableToLoadError } from '../../components';
import { usePrematchData } from '../../hooks';
import { isStatisticsTabEmpty } from './isStatisticsTabEmpty';
import OverviewSection from './OverviewSection';
import PreviousMeetingsSection from './PreviousMeetingsSection';
import VictoryProbabilitySection from './VictoryProbabilitySection';
import LastFiveGamesSection from './LastFiveGamesSection';
import TopGoalscorersSection from './TopGoalscorersSection';
import SeasonStatisticsSection from './SeasonStatisticsSection';
import OtherInfosSection from './OtherInfosSection';

export default function StatisticsTab() {
  const { statistics, statisticsStatus, refetchAll } = usePrematchData();
  const track = useTrack();

  const handleRetryClick = () => {
    track(TrackingEvents.CtaClick, {
      tab: TrackingTabs.Stats,
      element: TrackingElements.Retry,
    });
    refetchAll();
  };
  const platform = usePlatform();

  if (statisticsStatus === 'pending') {
    return (
      <StatisticsSkeleton
        className={clsx({
          'pt-6 px-3 pb-3': platform === Platforms.MOBILE,
          'pt-3': platform !== Platforms.MOBILE,
        })}
      />
    );
  }

  if (statisticsStatus === 'error') {
    return <UnableToLoadError onRetryClick={handleRetryClick} />;
  }

  if (statistics === null || isStatisticsTabEmpty(statistics)) {
    return <NoDataError />;
  }

  return (
    <div
      className={clsx('flex flex-col', {
        'pt-6 px-3 pb-3 gap-3': platform === Platforms.MOBILE,
        'pt-3 gap-2': platform !== Platforms.MOBILE,
      })}
    >
      <OverviewSection />
      <PreviousMeetingsSection />
      <VictoryProbabilitySection />
      <LastFiveGamesSection />
      <TopGoalscorersSection />
      <SeasonStatisticsSection />
      <OtherInfosSection />
    </div>
  );
}
